import { render, staticRenderFns } from "./Textarea2.vue?vue&type=template&id=594ead63"
import script from "./Textarea2.vue?vue&type=script&lang=js"
export * from "./Textarea2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports